export default __webpack_public_path__ + "static/media/product-page.aad5a805.png";